import styled from "styled-components";
import { Input, Select, Button, Table } from "antd";
import { DataValue, GhostButtonComponent, PrimaryButtonComponent, InputField } from "../../../../CommonComponents/commonStyles";
import Zipcode from "../../../../CommonComponents/Zipcode/Zipcode";

export const SACContainer = styled.div`
  margin: ${props => props.theme.spacing.margins.YBetween};
  @media only screen and (max-width: 680px) {
    margin: 0px 10px;
  }
`;

export const SearchResult = styled.div`
  border-top: 1px solid ${props => props.theme.border.divider };
  .wrapper: nth-child(odd) {
    background: ${props => props.theme.backgroundColor.layoutLight};
  }
`;

export const CharityButton = styled(PrimaryButtonComponent)`
  width: 27% !important;
  height: 30px;
  border-radius: ${props => props.theme.fontSize.primary};
  font-size:  ${props => props.theme.fontSize.quaternary};
  line-height: ${props => props.theme.lineHeight.h5};
`;

export const TitleHeading = styled.h3`
  font-family:${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const ClearList = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  padding: ${props => props.theme.spacing.paddings.webBase};
  a {
    color: ${props => props.theme.backgroundColor.tealBlue};
    text-decoration: underline;
  }
`;

export const MobileInnerWrapper = styled.div`
  .ant-row {
    padding-top: ${props => props.theme.spacing.paddings.smPadding};
    padding-bottom: ${props => props.theme.spacing.paddings.smPadding};
  }
  .ant-row .ant-col:last-child {
    padding-left: ${props => props.theme.spacing.paddings.webBase};
  }
  .ant-row: first-child {
    border-bottom: 1px solid ${props => props.theme.backgroundColor.layoutDark};
  }
  .ant-row: last-child {
    padding-top: ${props => props.theme.spacing.paddings.webBase};
    padding-bottom: ${props => props.theme.spacing.paddings.webBase};  
  }
`;

export const MobileCard = styled.div`
  font-family:${props => props.theme.fontFamily.helveticaNeue};
  padding: ${props => props.theme.spacing.paddings.smPadding};
  background: ${props => props.theme.backgroundColor.cardDark};
  border: 1px solid ${props => props.theme.backgroundColor.layoutDark};
  width: 100%;
  margin-bottom: ${props => props.theme.spacing.paddings.webBase};
`;

export const CharityList = styled(Table)`
  font-family:${props => props.theme.fontFamily.helveticaNeue};
  .ant-table-row:nth-child(even) {
    background: ${props => props.theme.backgroundColor.lightGrey};
  }
  tr.ant-table-row > td > a {
    color: ${props => props.theme.backgroundColor.tealBlue};
  }
  tr.ant-table-row > td {
    width: 20%;
  }
  tr.ant-table-row > td:nth-child(2) {
    width: 40%;
  }
  @media all and (-ms-high-contrast: none) {
    thead > tr > th {
      padding-left: ${props => props.theme.spacing.paddings.noPadding};
    }
  }
`;

export const SACTitle = styled.h1`
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-size: ${props => props.theme.fontSize.h1};
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: 15px;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
`;

export const AboutCharity = styled(DataValue)`
  width: 80%;
  color: ${props => props.theme.fontColors.textColor};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.colors.tabHead};
  @media only screen and (max-width: 680px) {
    width: 100%;
  }
`;

export const Limiter = styled.div`
  margin: 50px 0px;
  border-bottom: 1px solid ${props => props.theme.backgroundColor.cardGridDivider};
`;

export const CancelButton = styled(Button)`
  width: 25%;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSize.heading};
  color: ${props => props.theme.colors.primaryColor};
  border: 1px solid ${props => props.theme.colors.primaryColor};
  border-radius: 0px !important;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  height: 50px;
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primaryColor};
    border: 1px solid ${props => props.theme.colors.primaryColor};
  }
  @media only screen and (max-width: 990px) {
    width: 100%;
  }
`;

export const OkButton = styled(Button)`
  width: 25%;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.primaryColor};
  font-size: ${props => props.theme.fontSize.heading};
  color: ${props => props.theme.colors.white};
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  border-radius: 0px;
  height: 50px;
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.primaryColor};
    color: ${props => props.theme.colors.white};
    border: ${props => props.borderHover};
    border-color: ${props => props.theme.colors.primaryColor};
  }
  @media only screen and (max-width: 990px) {
    width: 100%;
  }
`;

export const CharityDetailsHeading = styled.div`
  &.contact {
    margin-bottom:0px;
  }
  margin-bottom: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width:680px) {
    font-size: ${props => props.theme.fontSize.h5};
    &.contact {
      margin-bottom: ${props => props.theme.spacing.paddings.mobPagesX};
    }
  }
`;

export const CharityLabel = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
letter-spacing: ${props => props.theme.letterSpacing.zero};
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.textColor};
${({ addr }) =>
  addr &&
  `
padding-top: 35px
  `}
@media only screen and (max-width:680px) {
  padding-top: 0px;
}
`;

export const CharityInput = styled(InputField)`
  padding: 4px 11px;
  margin: 5px 0px;
  height: 40px;
  width: 300px;
  @media only screen  and (max-width: 991px) {
    width: 300px !important;
  };
  @media only screen and (max-width: 680px) {
    width: 89vw !important;
  }
`;

export const CharityZipcode = styled(Zipcode)`
  color: ${props=>props.theme.fontColors.textColor};
  font-family: ${props=>props.theme.fontFamily.helveticaNeue};
  font-size: ${props=>props.theme.fontSize.primary};
`;

export const ContactInput = styled(Input)`
  height: 40px;
  width: 300px;
  border-radius: 0px !important;
  margin: 0;
  @media only screen and (max-width: 680px) {
    margin: 20px 0px;
    width: 100% !important;
  }
`;
export const Detail = styled.div`
  padding-right: 20px;
  margin-right: 10px; 
  @media only screen and (max-width: 680px) {
    ${({ contact }) => (contact ? `width: 103%` : `width: 100%`)};
    padding: 0px;
    margin: 0px 2px;
  }
`;

export const AddrDetail = styled.div`
width: 55.2% 
padding-right:20px;
margin-right:10px;
@media only screen and (max-width: 680px) {
  width: 100%;
  margin: 0px;
  padding: 0px;
}
`;

export const Groups = styled.div`
  dislay: flex;
  flex-direction: row;
  @media only screen and (max-width: 680px) {
    display: flex;
    flex-direction: column;
    padding-top: 0px;
  }
   {
    ${({ pad }) =>
      pad &&
      `
    padding-top: 40px;
    @media only screen and (max-width: 680px) {
      padding-top:0px;
    }
  `}
  }
`;

export const CGroups = styled.div`
  dislay: flex !important;
  flex-direction: row;
  justify-content: unset;
  align-items: flex-end;
  margin-top: 35px;
  @media only screen and (max-width: 680px) {
    display: flex;
    flex-direction: column;
    margin-top: 0px;
  }
`;

export const Note = styled.div`
  font-family:${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary}
  span {
    margin-bottom: 5px;
    font-family:${props => props.theme.fontFamily.helveticaNeueBold};
    color: ${props => props.theme.fontColors.headingColor};
  }
  @media only screen and (max-width: 680px) {
    width: 95%;
    font-size: ${props => props.theme.fontSize.secondary};
    span {
      line-height: ${props => props.theme.lineHeight.note};
    }
  }
`;

export const Warning = styled.div`
  margin-top: 0px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  font-size: ${props => props.theme.fontSize.primary};
  color:${props => props.theme.fontColors.error};
  @media only screen and (min-width: 577px) {
    width: 300px;
  }
  @media only screen and (max-width: 680px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative
    padding: 0px 0px 15px 0px;
  }
`;

export const NoLabel = styled.div`
  visibility: hidden;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  ${({ addr }) =>
    addr &&
    `
  padding-top:35px
    `}
  @media only screen and (max-width:680px) {
    padding-top: 0px;
    &.freeSpace {
      line-height: ${props => props.theme.lineHeight.noHeight};
    }
  }
`;

export const NoWarning = styled.div`
  visibility: hidden;
  position: absolute;
  @media only screen and (max-width: 680px) {
    display: flex;
    flex-direction: column;
    position: relative
    margin-bottom: 15px;
    &.freeSpace {
      margin-bottom: ${props => props.theme.spacing.margins.noMargin};
      line-height: ${props => props.theme.lineHeight.noHeight};
    }
  }
`;


export const SelectBox = styled(Select)`
  font-size: ${props=>props.theme.fontSize.primary};
  font-family: ${props=>props.theme.fontFamily.helveticaNeue};
  color: ${props=>props.theme.fontColors.textColor};
  width: 300px;
  @media only screen and (max-width: 680px) {
    width: 89vw;
  }
  .ant-select-selection {
    border-radius: 0px;
    height: 40px;
  }
  .ant-select-selection__placeholder {
    line-height: 28px !important;
    height: 28px;
    color: ${props => props.theme.fontColors.placeholder};
    @media only screen and (max-width: 680px) {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
    }
  }
  .ant-select-selection--multiple .ant-select-selection__rendered {
    height: 40px;
    margin-bottom: -4px;
  }
  .ant-select-selection-selected-value {
    line-height: 38px;
  }
  & > .ant-select-selection__choice {
    user-select: none;
    line-height: 32px;
  }
  .ant-select-arrow {
    top: 0;
    padding: 16px 13px;
    background-color: #f5f5f5;
    margin: 1px 1px;
    right: 0;
    bottom: 0;
  }
`;

export const TickMark = styled.div`
  border-radius: 50%;
  margin: 0px 20px 0px 0px;
  width: 50px;
  height: 50px;
  border: 2px solid #69923a;
  ::after {
    position: absolute;
    content: "";
    height: 28px;
    width: 2px;
    background: ${props => props.theme.colors.secondaryColor};
    transform: translate(26px, 10px) rotate(45deg);
  }
  ::before {
    position: absolute;
    content: "";
    height: 10px;
    width: 2px;
    background: ${props => props.theme.colors.secondaryColor};
    transform: translate(13px, 25px) rotate(135deg);
  }
`;

export const SuggestedMessage = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color:${props => props.theme.colors.secondaryColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
  @media only screen and (max-width: 680px) {
    width: 70%;
    font-weight: ${props => props.theme.fontWeight.w300};
  }
`;

export const RowFlex = styled.div`
  margin: 50px 0px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  @media only screen and (max-width: 680px) {
    flex-direction: column;
  }
`;

export const SuggestedContainer = styled.div`
  margin: 60px 0px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const HalfWidthContainer = styled.div`
  width: 50%;
  @media only screen and (max-width: 680px) {
    width: 100%;
    &:first-child {
      padding-bottom: ${props => props.theme.spacing.paddings.mdPadding};
      margin-bottom: ${props => props.theme.spacing.margins.mdMargin};
      border-bottom: 1px solid ${props => props.theme.colors.border};
    }
  }
`;

export const DetailsLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.twoRem};
  @media only screen and (max-width: 680px) {
    font-weight: ${props => props.theme.fontWeight.normal};
  };
`;
export const CharityDetailLabels = styled.div`  
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.twoRem};
  @media only screen and (max-width: 680px) {
    font-weight: ${props => props.theme.fontWeight.normal};
  }
`;

export const Flex = styled.div`
  display: flex;  
`;

export const DetailsHeading = styled(CharityDetailsHeading)`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  padding-bottom: 5px !important;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  margin-bottom: 0px;
  @media only screen and (max-width: 680px) {
    width: 100%;
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const AddresstTitle = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  margin: 40px 0 20px 0;
  font-weight: ${props => props.theme.fontWeight.bold};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 680px) {
    padding-top: 0px;
    margin: 0px 0 20px 0;
  }
`;

export const SACvalues = styled.span`
  margin-left: 8px;
`;

export const ContinueWrapper = styled.div``;
